/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CustomerWalletShowPathParams, CustomerWalletShowResponse } from '../types/CustomerWalletShow'

/**
 * GET /:organisation/wallet
 * @see backend/nexus/modules/Billing/Http/Controllers/CustomerWalletController.php CustomerWalletController::show
 */
export async function customerWalletShow(
	organisation: CustomerWalletShowPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CustomerWalletShowResponse>> {
	return axiosInstance.get(`/${organisation}/wallet`, config)
}
